import React, { useState } from 'react';
import { useT } from '../../helpers/i18n';

import Checkers from '../../helpers/class/Checkers';
import MasonryType from '../templates/articles/types/MasonryType';

const MAX_VISIBLE_FACILITIES = 4;

function FacilitiesLine ( { facilities }: { facilities: string[] } ) {
    const t = useT();
    const [ expanded, setExpanded ] = useState<boolean>( false );
    const hasMore = facilities.length > MAX_VISIBLE_FACILITIES;
    const visible = expanded || !hasMore ? facilities : facilities.slice( 0, MAX_VISIBLE_FACILITIES );

    return (
        <p className="hint-text">
            {visible.join( ' · ' )}
            {
                hasMore &&
                    <>
                        {' · '}
                        <a href="javascript:void(0)"
                           className="bold"
                           style={{ textDecoration: 'underline', color: 'inherit' }}
                           onClick={() => setExpanded( !expanded )}>
                            {expanded ? t('common.showLess') : t('common.showMore')}
                        </a>
                    </>
            }
        </p>
    );
}

interface PropertyGalleryContentProps {
    albums: any[]
    propertyPhotos?: any[]
    onSelectAlbum?: ( albumId: string ) => void
}

export default function PropertyGalleryContent ( { albums, propertyPhotos, onSelectAlbum }: PropertyGalleryContentProps ) {
  const t = useT();

    const validAlbums = ( Checkers.isValidArray( albums ) ? albums : [] )
        .filter( ( album ) => Checkers.isValidArray( album.photos ) );

    const validPropertyPhotos = Checkers.isValidArray( propertyPhotos ) ? propertyPhotos : [];

    const allAlbums = validPropertyPhotos.length > 0
        ? [ { id: 'main-photos', title: t('gallery.main'), photos: validPropertyPhotos }, ...validAlbums ]
        : validAlbums;

    return (
        <div className="container">

            {
                allAlbums.length > 1 &&
                    <section className="p-b-20 p-t-40">
                        <div className="masonry">
                            <div className="mzn-grid mzn-grid-covers">
                                {
                                    allAlbums.map( ( album ) => {
                                        const cover = Checkers.isValidArray( album.photos ) ? album.photos[0] : null;
                                        if ( cover == null ) {
                                            return null;
                                        }
                                        const src = cover.image_thumb != undefined ? cover.image_thumb : cover.image;
                                        return (
                                            <a
                                                className="mzn-card"
                                                href={'#gallery-' + album.id}
                                                key={album.id}
                                                onClick={ onSelectAlbum ? ( e ) => {
                                                    e.preventDefault();
                                                    onSelectAlbum( album.id );
                                                } : undefined }
                                            >
                                                <div className="mzn-imgwrap">
                                                    <img src={src} alt={album.title} loading="lazy" />
                                                </div>
                                                <div className="mzn-caption fs-12">{album.title}</div>
                                            </a>
                                        );
                                    } )
                                }
                            </div>
                        </div>
                    </section>
            }

            {
                allAlbums.map( ( album ) => (
                    Checkers.isValidArray( album.photos ) &&
                        <section className="p-t-30 p-b-30" id={'gallery-' + album.id} key={album.id}>
                            <div className="masonry">
                                <div className="row">
                                    <div className="col-md-4 mzn-gallery-info mb-4">
                                        <h2 className="mb-0">{album.title}</h2>
                                        {
                                            Checkers.isValidString( album.description ) &&
                                                <p className="hint-text">{album.description}</p>
                                        }
                                        {
                                            Checkers.isValidArray( album.facilities ) &&
                                                <FacilitiesLine facilities={album.facilities} />
                                        }
                                    </div>
                                    <div className="col-md-8 mzn-gallery-photos">
                                        <MasonryType
                                            type={'gallery'}
                                            content={{}}
                                            builder={{}}
                                            textColor={false}
                                            backgroundColor={null}
                                            itemClassName={''}
                                            loadingArticles={false}
                                            articlesLimit={null}
                                            fancyboxGroup={'album-all'}
                                            hideCaption={true}
                                            columns={{ xs: 1, sm: 2 }}
                                            setClass={() => ''}
                                            articles={
                                                album.photos.map( ( photo, index ) => {
                                                    const caption = Checkers.isValidString( photo.caption ) ? photo.caption.trim() : '';
                                                    const src = photo.image_thumb != undefined ? photo.image_thumb : photo.image;
                                                    const photoKey = photo.id != null ? photo.id : photo.image_id != null ? photo.image_id : src;
                                                    return {
                                                        id: photoKey != null ? photoKey.toString() : src,
                                                        title: caption || ( album.title + ' photo ' + ( index + 1 ) ),
                                                        caption: caption,
                                                        image: src,
                                                        fancyboxSrc: photo.image,
                                                        has_description: '0'
                                                    };
                                                } )
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </section>
                ) )
            }
        </div>
    );
}
